import _extends from "@babel/runtime/helpers/extends";
import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';
import { Pixall, Google } from '../../analytics';
import { DataLayerTransformer } from '../../transformers/pixall';
import { getInventoryOwnerById } from '../../utilities';
var ownerWebsiteClickHelper = function ownerWebsiteClickHelper(_ref, option) {
  var _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    _ref$pixallData = _ref.pixallData,
    pixallData = _ref$pixallData === void 0 ? {} : _ref$pixallData,
    _ref$googleData = _ref.googleData,
    googleData = _ref$googleData === void 0 ? {} : _ref$googleData,
    dataLayer = _ref.dataLayer,
    event = _ref.event,
    state = _ref.state,
    userDuck = _ref.userDuck,
    isEsntial = _ref.isEsntial,
    isAccelerate = _ref.isAccelerate,
    disablePixall = _ref.disablePixall;
  var inventoryId = data.inventoryId,
    ownerId = data.ownerId,
    _data$par = data.par,
    par = _data$par === void 0 ? 'v_lstg' : _data$par,
    _data$ctaLocation = data.ctaLocation,
    ctaLocation = _data$ctaLocation === void 0 ? '' : _data$ctaLocation,
    _data$ecommLink = data.ecommLink,
    ecommLink = _data$ecommLink === void 0 ? false : _data$ecommLink,
    _data$label = data.label,
    label = _data$label === void 0 ? '' : _data$label,
    clickType = data.clickType;
  var owner = _get(state, "owners." + ownerId, {});
  var pageName = _get(dataLayer, 'page.pageName', '');
  var pageId = DataLayerTransformer.getPageId(dataLayer);
  var inventory = getInventoryOwnerById(state, inventoryId);
  var prefix = _kebabCase(label);
  var searchZip = userDuck ? userDuck.selectors.getLocation(state).zip : _get(state, 'query.zip', '');
  var eventSource = 'dealership';
  var eventResult = googleData.eventResult;
  var cmp = data.cmp;
  if (pageName === 'fyd_srl') {
    var _dataLayer$user;
    searchZip = ((_dataLayer$user = dataLayer.user) == null ? void 0 : _dataLayer$user.zipCode) || '';
  }
  if (ecommLink) {
    eventResult = "sitelink::ecomm-deeplink::" + ctaLocation;
    cmp = 'exp_pymt_ecomm_dplnk';
    if (isEsntial && isAccelerate) {
      eventResult = "sitelink::ecomm-deeplink::purchase-now::" + ctaLocation;
      cmp = 'pur_now_ecomm_dplnk';
    } else if (isEsntial) {
      eventResult = "sitelink::esntial::" + ctaLocation;
      eventSource = 'vehicle';
      cmp = 'cnt_onln_esntial';
    }
    if (prefix === 'buy-now') {
      eventResult = "sitelink::ecomm-deeplink::" + prefix + "::" + ctaLocation;
      cmp = prefix + "_ecomm_dplnk";
    }
  }
  if (!disablePixall) {
    Pixall.sendClickEvent({
      pixallData: _extends({}, pixallData, {
        clickTypeToListingType: pageId === 'fyc_vdp' || clickType === 'recommendations'
      }),
      label: "Click to Dealer Site - " + cmp + " - " + pageId,
      eventSource: eventSource,
      feature: 'Drive the 5',
      inventory: inventory,
      owner: owner,
      par: par,
      zipCode: searchZip,
      searchFacetZipCode: searchZip,
      hasListingType: pixallData.hasListingType
    }, dataLayer, option);
  }
  if (Object.keys(googleData).length > 0) {
    Google.sendClickEvent(_extends({}, googleData, {
      eventResult: eventResult
    }), option);
  }
  return {
    cmp: cmp
  };
};
export default ownerWebsiteClickHelper;